/* eslint-disable react/prop-types */
import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { postForm } from 'js/actions/formsAction';

import { Button, TextField, Grid2 } from '@mui/material';

import { makeStyles } from '@mui/styles';
import styles from './styles';
import Swal from 'sweetalert2';
import { useIntl } from 'react-intl';

const useStyles = makeStyles(styles);

function NameConcentratorForm(props) {
  const intl = useIntl();
  const { register, handleSubmit } = useForm();
  const dispatch = useDispatch();

  const onSubmit = (values) => {
    if (!isValid(values.charge_name)) {
      Swal.fire({
        title: 'Error',
        text: 'El nombre de la medición no puede tener los simbolos  / \\ : ? * ',
        icon: 'error',
      });
      return;
    }

    dispatch(postForm(values));
    props.nextStep();
  };

  const isValid = (txt) => {
    let bValid = true;
    let restricted = ['/', '\\', ':', '?', '*'];

    for (var idx = 0; idx < restricted.length; idx++) {
      if (txt.indexOf(restricted[idx]) > -1) {
        return false;
      }
    }
    return bValid;
  };

  const classes = useStyles();

  return (
    <Grid2 className={classes.root} container={true}>
      <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        <TextField
          className={classes.textField}
          {...register('charge_name')}
          label={intl.formatMessage({
            id: 'app.chargesCards.addCharge.stepper.descrip.chargeNameLbl',
          })}
          name="charge_name"
          required
          variant="outlined"
        />

        <TextField
          className={classes.textField}
          {...register('charge_description')}
          label={intl.formatMessage({
            id: 'app.chargesCards.addCharge.stepper.descrip.chargeDescripLbl',
          })}
          name="charge_description"
          required
          variant="outlined"
        />

        <TextField
          className={classes.textField}
          {...register('charge_ubication')}
          label={intl.formatMessage({
            id: 'app.chargesCards.addCharge.stepper.descrip.chargeLocLbl',
          })}
          name="charge_ubication"
          variant="outlined"
        />

        <Button
          className={classes.button}
          color="secondary"
          size="large"
          type="submit"
          variant="contained"
        >
          {intl.formatMessage({
            id: 'app.chargesCards.addCharge.stepper.descrip.saveAndContinueLbl',
          })}
        </Button>
      </form>
    </Grid2>
  );
}

export default NameConcentratorForm;
